export const toEmptyStringIfNull = (value: unknown | undefined): unknown => {
  if (value === undefined || value === null) {
    return '';
  } else {
    return value;
  }
};
